import { jsx as r } from "react/jsx-runtime";
import { useRef as f, useEffect as l } from "react";
function g(e) {
  const c = f(null);
  function s() {
    const a = e.host || "https://app.documenso.com", n = btoa(
      encodeURIComponent(
        JSON.stringify({
          name: e.name,
          lockName: e.lockName,
          email: e.email,
          lockEmail: e.lockEmail,
          css: e.css,
          cssVars: e.cssVars,
          darkModeDisabled: e.darkModeDisabled
        })
      )
    ), t = new URL(`/embed/direct/${e.token}`, a);
    return e.externalId && t.searchParams.set("externalId", e.externalId), `${t}#${n}`;
  }
  function d(a) {
    var n, t, m, i, o, u;
    if (((n = c.current) == null ? void 0 : n.contentWindow) === a.source)
      switch (a.data.action) {
        case "document-ready":
          (t = e.onDocumentReady) == null || t.call(e);
          break;
        case "document-completed":
          (m = e.onDocumentCompleted) == null || m.call(e, a.data.data);
          break;
        case "document-error":
          (i = e.onDocumentError) == null || i.call(e, a.data.data);
          break;
        case "field-signed":
          (o = e.onFieldSigned) == null || o.call(e);
          break;
        case "field-unsigned":
          (u = e.onFieldUnsigned) == null || u.call(e);
          break;
      }
  }
  return l(() => {
    window.addEventListener("message", d);
  }, []), l(() => () => {
    window.removeEventListener("message", d);
  }, []), /* @__PURE__ */ r("iframe", { ref: c, className: e.className, src: s() });
}
function w(e) {
  const c = f(null);
  function s() {
    const a = e.host || "https://app.documenso.com", n = btoa(
      encodeURIComponent(
        JSON.stringify({
          name: e.name,
          lockName: e.lockName,
          css: e.css,
          cssVars: e.cssVars,
          darkModeDisabled: e.darkModeDisabled
        })
      )
    );
    return `${new URL(`/embed/sign/${e.token}`, a)}#${n}`;
  }
  function d(a) {
    var n, t, m, i;
    if (((n = c.current) == null ? void 0 : n.contentWindow) === a.source)
      switch (a.data.action) {
        case "document-ready":
          (t = e.onDocumentReady) == null || t.call(e);
          break;
        case "document-completed":
          (m = e.onDocumentCompleted) == null || m.call(e, a.data.data);
          break;
        case "document-error":
          (i = e.onDocumentError) == null || i.call(e, a.data.data);
          break;
      }
  }
  return l(() => {
    window.addEventListener("message", d);
  }, []), l(() => () => {
    window.removeEventListener("message", d);
  }, []), /* @__PURE__ */ r("iframe", { ref: c, className: e.className, src: s() });
}
export {
  g as EmbedDirectTemplate,
  w as EmbedSignDocument
};
